import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../../reducers";
import { Combo2Service, ExcelService, PurchaseReportService } from "../../../../services/index";
declare var google;

@Component({
  selector: "wo-return-Inward-Report",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./woreturnInwardReport.html",
})
export class woreturnInwardReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gridOptions: any;
  dataList = [];
  qualityList: any;
  typeList: any;
  colorList: any;
  codeList: any;
  widthList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  finyearList = [];
  typeLists = ["REF.NO", "DESIGN WISE"];
  filter = {
    groupby: "REF_NO",
    wo_in_id : '',
    report_type :'REF.NO',
    design_no : '',
    color : '',
    wo_no : '',
    in_date : '',
    wo_date : ''

  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "po_no",
    orderDir: "asc",
  };
  printConfig: any = {
    title: "Cutting Report",
    columns: [],
    rows: [],
  };

  partyList = [];
  exceldata: any;

  @ViewChild("filterPanel") filterPanel;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  columns = [];
  partycodeList = [];
  toggleCol = [];
  menu: any;
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    private purReport: PurchaseReportService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    public toasterService: ToasterService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.finyearCombo();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  onCellClick(event) {
    let row = event.row;
    if(this.filter.report_type == 'REF.NO'){
      if(this.filter.groupby == 'REF_NO'){
        this.filter.wo_in_id = row.wo_in_id;
        this.filter.groupby = 'BARCODE';
      }
    }
    if(this.filter.report_type == 'DESIGN WISE'){
      if(this.filter.groupby == 'DESIGN'){
        this.filter.design_no = row.design_no;
        this.filter.groupby = 'DESIGNCOLOR';
      }
    }
    

    this.getwoReturnInwardReport();
    
  }

  onbackbutton(){
    if(this.filter.report_type == 'REF.NO'){
      if(this.filter.groupby == 'BARCODE'){
        this.filter.groupby = 'REF_NO';
          this.filter.wo_in_id = '';
      }
    }
    if(this.filter.report_type == 'DESIGN WISE'){
      if(this.filter.groupby == 'DESIGNCOLOR'){
        this.filter.groupby = 'DESIGN';
          this.filter.design_no = '';
      }
    }

    this.getwoReturnInwardReport();
}

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

 

  

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    
  }

  

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    if(this.filter.report_type == 'REF.NO'){
      this.filter.wo_in_id = '';
      this.filter.groupby = 'REF_NO';
    }

    if(this.filter.report_type == 'DESIGN WISE'){
      this.filter.design_no = '';
      this.filter.groupby = 'DESIGN';
    }
    this.getwoReturnInwardReport();
  }

  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.finyearCtrl.setValue(res.data[0].fin_id);
      this.getwoReturnInwardReport();
    });
  }

 

  getwoReturnInwardReport(): void {
    this.filter.wo_date = this.datePipe.transform(this.filter.wo_date, 'yyyy-MM-dd');
    this.filter.in_date = this.datePipe.transform(this.filter.in_date, 'yyyy-MM-dd');
    let params = {
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.purReport
      .getwoReturnInwardReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;

        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };
        that.printConfig = {
          title: "Cutting Report",
          columns: res.columns,
          rows: that.orderList,
        };
        that.exceldata = that.getData(res.columns, res.data);
      });
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/woreports/woreturnInwardReport/woreturnInwardReport.ts